import styled from 'react-emotion';

export const Container = styled('div')`
  max-width: ${({ theme }) => theme.general.maxWidth};

  display: flex;
  width: 100%;
  flex-wrap: wrap;

  ${({ theme }) => theme.below.lg} {
    padding: 1rem;
  }

  ${({ theme }) => theme.below.sm} {
    padding: 0;
  }
`;
